if (!customElements.get('length-selector-component')) {
  customElements.define(
    'length-selector-component',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick.bind(this));
      }

      // Scripts inserted via `el.innerHTML = ...` never execute — that's a
      // browser security rule, not a Shopify quirk, and it applies to both
      // inline <script> blocks and <script src="..."> tags. That's exactly
      // what was breaking "Your Bundle": switching Regular/Tall replaced the
      // whole section's HTML, but every script inside it (the one that sets
      // window.currentProductData, and the custom-pack-builder.js tag that
      // actually makes the bundle interactive) silently never ran again.
      // Recreating each <script> tag from scratch and reinserting it forces
      // the browser to run it, same as it would on a normal page load.
      reviveScripts(container) {
        const scripts = Array.from(container.querySelectorAll('script'));
        scripts.forEach(function (oldScript) {
          const newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach(function (attr) {
            newScript.setAttribute(attr.name, attr.value);
          });
          newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      }

      async onClick(event) {
        const link = event.target.closest('a.length-pill');
        if (!link) return;
        event.preventDefault(); // Prevent default link navigation

        if (link.classList.contains('length-pill--active')) return;

        const url = link.href;
        const sectionId = this.dataset.sectionId;
        const wrapperId = 'shopify-section-' + sectionId;
        const currentWrapper = document.getElementById(wrapperId);

        if (!currentWrapper) {
          window.location.href = url;
          return;
        }

        this.classList.add('length-selector--loading');

        try {
          // Add section_id parameter to fetch ONLY this specific section HTML cleanly
          const fetchUrl = url + (url.includes('?') ? '&' : '?') + 'section_id=' + sectionId;
          const response = await fetch(fetchUrl);

          if (!response.ok) throw new Error('Fetch failed');

          const htmlText = await response.text();
          const doc = new DOMParser().parseFromString(htmlText, 'text/html');

          // Check if section HTML was received directly or wrapped
          const newWrapper = doc.getElementById(wrapperId) || doc.body;

          if (newWrapper && newWrapper.innerHTML.trim() !== '') {
            // Update section HTML smoothly
            currentWrapper.innerHTML = newWrapper.innerHTML;

            // Bring the swapped-in markup's scripts back to life (see
            // reviveScripts above) — without this, everything downstream
            // of this swap (window.currentProductData, and the pack builder
            // re-initialising itself) just silently stays dead.
            this.reviveScripts(currentWrapper);

            // Update URL bar silently without reloading page
            window.history.pushState({}, '', url);

            // Re-trigger Shopify events for dynamic components / scripts if needed
            currentWrapper.dispatchEvent(
              new CustomEvent('shopify:section:load', {
                bubbles: true,
                detail: { sectionId: sectionId }
              })
            );
          } else {
            window.location.href = url;
          }
        } catch (error) {
          console.error('Error switching length variant:', error);
          window.location.href = url;
        } finally {
          this.classList.remove('length-selector--loading');
        }
      }
    }
  );
}
